import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ReviewDataService } from '../../../services/raintree/Transmission/review-data.service';
import { SerialNoCellComponent } from '../../../table-cell/serial-no-cell.component';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { FwDetailsPopupComponent } from '../../fw-details-popup/fw-details-popup.component';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { ReviewService } from '../../../services/common/review-shared';
import { StatusResolverService } from '../../../services/raintree/Transmission/status-resolver.service';
import { DpLoaderComponent } from '../../../common-component/dp-loader/dp-loader.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommonModule } from '@angular/common';
import { MergeFcPopupComponent } from '../../merge-fc-popup/merge-fc-popup.component';
import { ManageUserReviewComponent } from '../../../table-cell/manage-user-review-cell.component';
import { DistrictCellComponent } from '../../../table-cell/district-review-table';
import { StateCellComponent } from '../../../table-cell/state-review-table';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-merge-fc-data',
  standalone: true,
  imports: [
    DpTableComponent,
    LoaderComponent,
    MatDialogModule,
    DpLoaderComponent,
    InfiniteScrollModule, FormsModule, ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: './merge-fc-data.component.html',
  styleUrl: './merge-fc-data.component.scss',
})
export class MergeFcDataComponent implements OnInit {
  responseData: any = [];
  constructor(
    private reviewService: ReviewService,
    private _reviewDataService: ReviewDataService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
    private getstatusservice: StatusResolverService,
  ) { }
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  slNo = new FormControl('')
  public districtName: string = '';
  public stateName: string = '';
  public isMobileDevice: boolean = false;
  isLoading: boolean = false;
  isLoader: boolean = false;
  searchPgNo: number = 1;
  searchVal: any = {};
  // slNo = new FormControl('')
  allDataLoaded: boolean = false;
  isScrollable: boolean = false;
  tempData: any[] = [];
  public displayColumnData: any = [
    {
      id: 'memkey',
      name: 'Sl.no',
    },
    {
      id: 'fullName',
      name: 'Full name',
    },
    {
      id: 'guardianName',
      name: 'Guardian Name',
    },
    {
      id: 'ritwikName',
      name: 'Ritwik Name',
    },
    {
      id: 'reqBy',
      name: 'Field worker',
    },
    {
      id: 'manageUser',
      name: '',
    },
  ];
  public displayStateColumnData: any = [
    {
      id: 'country',
      name: 'Country',
    },
    {
      id: 'stateName',
      name: 'State',
    },
    {
      id: 'pending',
      name: 'Count',
    },
  ];
  public displayColumnDataForDistrict: any = [
    {
      id: 'stateName',
      name: 'State',
    },
    {
      id: 'districtName',
      name: 'District',
    },
    {
      id: 'pending',
      name: 'Count',
    },
  ];
  cellComponentMapDistrict = {
    districtName: DistrictCellComponent,
    // state: StateCellComponent,
  };
  cellComponentMapState = {
    stateName: StateCellComponent,
  };
  updateData: any;
  label: any;
  public tabLists: any = [];
  pgNo: number = 1;
  obj: any = {}

  columnConfs = {
    memberKey: { cssClass: 'slnowidth' },
  };
  cellComponentMap = {
    memkey: SerialNoCellComponent,
    manageUser: ManageUserReviewComponent,
  };


  ngOnInit(): void {
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.callApiService();
    this.subscribeToRouteParams()

  }
  mobOnClick(rowData: any, type: string) {
    if (type === 'fw') rowData = { ...rowData, fw: true };
    else rowData = { ...rowData, count: true };
    this.openDialog(rowData);
  }
  openDialog(rowData: any) {
    this.isLoading = true;
    if (rowData.fw) {
      this.dialog.open(FwDetailsPopupComponent, {
        data: rowData,
      });
    } else {
      this._reviewDataService.fetchMergePendingData(rowData.memkey).subscribe({
        next: (response: any) => {
          if (!response.error && response.data.length >= 1) {
            this.isLoading = false;
            const dialogRef = this.dialog.open(MergeFcPopupComponent, {
              data: { memData: rowData, fc: response.data },
            });
            dialogRef.afterClosed().subscribe((value) => {
              if (value) {
                this.isLoading = true;
                const index = this.responseData.findIndex(
                  (item: { memKey: any }) => item.memKey === rowData.memKey
                );
                if (index > -1) {
                  this.responseData.splice(index, 1);
                  this.isLoading = false;
                }
              }
            });
          } else {
            this.isLoading = false;
            this.toaster.error('No data found');
          }
        },
        error: (error: any) => {
          this.isLoading = false;
        },
      });
    }
    this.isLoading = false;
  }


  subscribeToRouteParams(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.pgNo = 1
      if (params['state'] && params['district'] && params['country']) {
        this.districtName = params['district']
        this.stateName = params['state']
        this.obj = {
          uiState: params['state'],
          uiDistrict: params['district']
        }
        this.fetchMergedDataApi(true)
      } else if (params['country'] && params['state'] && !params['district']) {
        this.districtName = ''
        this.obj = {
          uiState: params['state']
        }
        this.stateName = params['state']
        this.fetchStateCount()
      }
      else if (params['country'] && !params['state'] && !params['district']) {
        this.stateName = this.districtName = ''
        this.obj = {}
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { country: 'India' },
        });

        this.fetchStateCount()
      }
      else if (!params['country'] && !params['state'] && !params['district']) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { country: 'India' },
        });
      }
    }
    )
  }
  onScroll() {
    if (this.isScrollable) {
      this.pgNo++;
      this.fetchMergedDataApi(false);
    }
  }
  openDistrictCount(event: any) {
    this.isLoader = true;
    if (event) {
      this.stateName = event.permanentState || event;
      localStorage.setItem('review-state', this.stateName)
      this.districtName = event.permanentDistrict ?? ''
      let routeObj: any = {
        state: this.stateName
      }
      this.districtName !== '' ? routeObj.district = this.districtName : ''
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: routeObj,
        queryParamsHandling: 'merge',
      });
      // this.route.queryParams.subscribe((params) => {
      //   this.stateNamePresent = 'state' in params;
      // });
      this.obj = { uiState: this.stateName }
      // this.fetchStateCount();
    }
  }
  private fetchMergedDataApi(scrollable: boolean): void {
    if (scrollable && this.pgNo === 1) this.isLoader = true
    if (scrollable) {
      this.pgNo = 1;
      this.isScrollable = true;
    }
    if (!scrollable && this.pgNo > 1) this.isLoading = true;

    this.obj.pageNo = this.pgNo
    let slNo: any = this.slNo?.value
    slNo?.length >= 8 ? this.obj = { ...this.obj, memKey: slNo } : ''
    this._reviewDataService.fetchMergeFCData(this.obj).subscribe(
      (res) => {
        if (res.data.length === 0) this.allDataLoaded = true;
        if (scrollable) {
          this.isLoader = this.isLoading = false
          this.responseData = res.data;
          this.responseData.forEach((data: any) => {
            data.manageUser = 'Manage';
          });
        } else {

          // if (this.pgNo > 1 && !scrollable){
          // console.log(this.responseData);

          this.responseData = [...this.responseData, ...res.data];
          // this.tempData = this.responseData;
          this.isLoader = this.isLoading = false;
        }
      },
      (error) => {
        this.isLoader = this.isLoading = false;
        this.toaster.error(error);
      }
    );
  }
  statusMap: any = []
  onSearchClick() {
    let value: any = this.slNo?.value
    if (value.length >= 8) {
      this.allDataLoaded = false
      this.pgNo = 1
      this.fetchMergedDataApi(true)
    } else
      this.toaster.error('Enter correct serial number')
  }
  callApiService() {
    this.getstatusservice.getStatusData().subscribe({
      next: (response: any) => {
        this.statusMap = new Map(
          response.data.map(
            (item: { status_code: any; status_desc: any }) => [
              item.status_code,
              item.status_desc,
            ]
          )
        );
      },
      error: (error: any) => {
        this.isLoader = false;
        this.toaster.error(error);
      },
    });
  }
  openDataTable(event: any) {
    if (event) {
      this.districtName = event;
      localStorage.setItem('review-district', this.districtName)
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { district: this.districtName },
        queryParamsHandling: 'merge',
      });
      this.obj.uiDistrict = this.districtName

    }
  }
  fetchStateCount() {
    this.isLoader = true
    this._reviewDataService.fetchPendingData(this.obj).subscribe(
      (res) => {
        if (this.stateName !== '')
          this.responseData = res.data
        else
          this.responseData = res.data.map((item: any) => ({ ...item, country: 'India' }));
        this.isLoader = false
      },
      (error) => {
        this.isLoader = false
        this.toaster.error(error);
      }
    );
  }

}
